<template>
  <!-- <MenuBar /> -->
  <ConfirmModal :popup="popup" @executePrimaryAction="handlePrimaryAction" ref="openModalBox" />
  <div v-if="showPopup">
    <PopupYAML :popup="popupData" :projectName="this.projectName" :setShowPop="setShowPop"
      :popupCommonData="this.popupCommonData" :loading="popUpLoading" :fileData="popupFileData"
      @popupRequestId="viewYAMLFile" />
  </div>
  <div v-if="showCalcPopup">
    <CalculateComplexityPopup :title="popupData.viewTitle" :project-param-id="projectParamId"
      @close="showCalcPopup = false" @reloadData="search" @openModal="openModalFromCalc" ref="removeRowRef" />
  </div>
  <TransformationFactoryPopup v-show="showTransformationFactoryPopup" @close="showTransformationFactoryPopup = false"
    @confirm="handleTransformationFactoryChoice" />
  <!-- Use Case Details Popup -->
  <div v-if="showUseCasePopup" class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5);"
    tabindex="-1" @click.self="showUseCasePopup = false" role="dialog" aria-modal="true"
    aria-labelledby="useCaseModalTitle">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="useCaseModalTitle">Use Case Details</h5>
          <button type="button" class="btn-close" @click="showUseCasePopup = false" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">Use Case</th>
                  <th scope="col">usecaseIds</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!useCaseData || useCaseData.length === 0">
                  <td colspan="2" class="text-center">No use cases found.</td>
                </tr>
                <tr v-else v-for="(item, index) in useCaseData" :key="index">
                  <td>{{ item.useCase }}</td>
                  <td>{{ item.usecaseIds }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isGridVisible" class="container-fluid mt-1">
    <div class="row">
      <div class="col">
        <!-- <div class="row"> -->
        <!--Revamp panel starts-->
        <div class="report-filter-bar row mb-1">
          <div class="col d-flex gap-2 justify-content">
            <!--Columns Dropdown-->
            <button type="button" class="btn btn-primary filterButton dropdown-toggle btn-sm" data-bs-toggle="dropdown"
              aria-expanded="false">
              Columns
            </button>
            <ul class="dropdown-menu fade">
              <li>
                <a class="dropdown-item" href="#">
                  <label>
                    <input type="checkbox" :value="'*'" v-model="selectedColumns" @change="handleColumnChange('*')" />
                    Select All
                  </label>
                </a>
              </li>
              <hr class="dropdown-divider" />
              <li v-for="(column, index) in tableConfigs" :key="index">
                <a class="dropdown-item" href="#">
                  <label>
                    <input type="checkbox" :value="column.name" :disabled="column.checked" v-model="selectedColumns"
                      @change="handleColumnChange(column.name)" />
                    {{ column.label }}
                  </label>
                </a>
              </li>
            </ul>
            <!--Status Dropdown-->
            <div v-if="tableProps.type == 'users'">
              <button type="button" class="btn btn-primary btn-sm filterButton dropdown-toggle"
                data-bs-toggle="dropdown" aria-expanded="false">
                State
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#">
                    <label>
                      <input type="checkbox" :value="'*'" v-model="stateFilter" @change="handleStateChange('*')" />
                      Select All
                    </label>
                  </a>
                </li>
                <hr class="dropdown-divider" />
                <li v-for="(status, name) in states" :key="name">
                  <a class="dropdown-item" href="#">
                    <label>
                      <input type="checkbox" :value="status.name" v-model="stateFilter"
                        @change="handleStateChange(status.name)" />
                      {{ status.label }}
                    </label>
                  </a>
                </li>
              </ul>
            </div>
            <div v-else>
              <button type="button" class="btn btn-primary btn-sm filterButton dropdown-toggle"
                data-bs-toggle="dropdown" aria-expanded="false">
                Status
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#">
                    <label>
                      <input type="checkbox" :value="'*'" v-model="selectedFilter" @change="handleStatusChange('*')" />
                      Select All
                    </label>
                  </a>
                </li>
                <hr class="dropdown-divider" />
                <li v-for="(status, name) in this.$statuses" :key="name">
                  <a class="dropdown-item" href="#">
                    <label>
                      <input type="checkbox" :value="status.name" v-model="selectedFilter"
                        @change="handleStatusChange(status.name)" />
                      {{ status.label }}
                    </label>
                  </a>
                </li>
              </ul>
            </div>
            <button class="btn btn-primary btn-sm filterButton dropdown-toggle" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <span>{{ searchConcept }}</span>
            </button>

            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item mt-1" href="#" @click="setSearchFilter('All Categories')">All Categories</a>
              </li>
              <hr class="dropdown-divider" />
              <li v-for="(searchColumns, index) in columns.search" :key="index">
                <a class="dropdown-item mt-1" href="#" @click="setSearchFilter(searchColumns)">{{ searchColumns.label
                }}</a>
              </li>

            </ul>
            <form class="search-form" @submit.prevent="performSearch">
              <input id="searchBar" class="form-control srchip" style="" v-model="searchQuery" @input="handleInputs"
                type="search" placeholder="" aria-label="Search" />
              <input class="btn btn-outline-dark" type="submit" value="Search" @click="searchWithQuery()" />
            </form>
            <button class="clear-filter-icon" @click="clearFilters">
              <img src="../../assets/icons/clear-filter-icon.svg" alt="filter-icon" class="filter-icon" />
            </button>
          </div>
          <div
            :class="(tableProps.type === type.PROJECT || tableProps.type === type.XML) ? 'col d-flex justify-content-end me-6' : 'col d-flex justify-content-end pe-0 me-6'">
            <div class="d-flex gap-2 align-items-center button-container me-4">
              <button v-if="tableProps.actions && tableProps.actions.download" class="cloud-download" @click="bulkDownload(selectedReqsForBulkOps)" :disabled="selectedReqsForBulkOps.length === 0" v-tooltip="getTooltipText(tableProps.actions.download.label)">
                <i v-if="tableProps.type === type.DOWNLOADS" class="fas fa-download"></i>
                <i v-else class="fas fa-cloud-download fa-sm"></i>
              </button>
              <button v-if="tableProps.actions && tableProps.actions.delete" type="button" class="btn-delete"
                @click="bulkDelete(selectedReqsForBulkOps)" :disabled="selectedReqsForBulkOps.length === 0"
                v-tooltip="getTooltipText(tableProps.actions.delete.label)">
              </button>
              <button v-if="tableProps.actions && tableProps.actions.view" class="btn-view"
                @click="bulkViewYAMLFile(selectedReqsForBulkOps)" :disabled="selectedReqsForBulkOps.length === 0"
                v-tooltip="getTooltipText(tableProps.actions.view.label)">
              </button>
              <button v-if="tableProps.actions && tableProps.actions.viewPopup" type="button" class="btn-view"
                @click="toggleTabs" :disabled="selectedReqsForBulkOps.length === 0"
                v-tooltip="getTooltipText(tableProps.actions.viewPopup.label)">
              </button>
              <button v-if="tableProps.actions && tableProps.actions.libarydownload" type="button"
                class="cloud-download" @click="connectorLibrary()" :disabled="selectedReqsForBulkOps.length === 0"
                v-tooltip="getTooltipText(tableProps.actions.libarydownload.label)">
                <i class="fa-regular fa-file-zipper"></i>
              </button>
              <button v-if="tableProps.actions && tableProps.actions.calculate" type="button" class="btn-calculate"
                @click="calculateComplexity()" :disabled="selectedReqsForBulkOps.length === 0"
                v-tooltip="getTooltipText(tableProps.actions.calculate.label)">
              </button>
              <button v-if="tableProps.actions && tableProps.actions.xslDiff" type="button" class="btn-show-difference"
                @click="xslShowDiff(selectedReqsForBulkOps)" :disabled="selectedReqsForBulkOps.length === 0"
                v-tooltip="getTooltipText(tableProps.actions.xslDiff.label)">
              </button>
              <button v-if="tableProps.actions && tableProps.actions.xmlDiff" type="button" class="btn-show-difference"
                @click="xmlShowDiff(selectedReqsForBulkOps)" :disabled="selectedReqsForBulkOps.length === 0"
                v-tooltip="getTooltipText(tableProps.actions.xmlDiff.label)">
              </button>
              <!-- <button v-if="tableProps.actions && tableProps.actions.transform" type="button" class="btn-transform" @click="xmlTransform(tableProps.type, selectedReqsForBulkOps)" :disabled="selectedReqsForBulkOps.length === 0" v-tooltip="getTooltipText(tableProps.actions.transform.label)">
              </button> -->
              <button v-if="tableProps.actions && tableProps.actions.restore" type="button" class="btn-restore"
                @click="restore(tableProps.type, selectedReqsForBulkOps)"
                :disabled="selectedReqsForBulkOps.length === 0"
                v-tooltip="getTooltipText(tableProps.actions.restore.label)">
              </button>
              <button v-if="tableProps.actions && tableProps.actions.generate" type="button" class="btn-generate"
                @click="generateOrchestrationConfig(selectedReqsForBulkOps)"
                :disabled="selectedReqsForBulkOps.length === 0"
                v-tooltip="getTooltipText(tableProps.actions.generate.label)">
              </button>

            </div>
          </div>
        </div>
        <Loading v-if="loading" />

        <div v-else class="table-responsive">
          <div>
            <table ref="requestTable" class="table table-hover table-borderless custom-table" @click.stop>
              <thead>
                <tr class="p-0">
                  <!--Table header to show menu icon in the header starts-->
                  <!-- <th v-if="isMultiSelectionAllowed" class="col align-middle table-header-sticky actions-dropdown-toggle">
                  </th> -->
                  <!--Table header to show menu icon in the header ends-->
                  <!--Table header to show selectAll checkbox in the header starts-->
                  <th v-if="isMultiSelectionAllowed" class="col align-middle table-header-sticky">
                    <input type="checkbox" v-model="selectAllCheckboxes" @change="toggleSelectAllCheckboxes" />
                  </th>
                  <!--Table header to show selectAll checkbox in the header ends-->
                  <th v-for="(header, index) in selectedConfigs" :key="header.name" scope="col"
                    class="col align-middle table-header-sticky" @mouseover="hoveredColumn = header.name"
                    @mouseleave="hoveredColumn = ''" :class="{ 'clickable': isSortable(header) }"
                    @click="isSortable(header) ? sort(header, index) : null">
                    <div class="pe-4">
                      {{ header.label }}
                    </div>
                    <div v-if="isSortable(header) && (hoveredColumn === header.name || sortColumn === header.name)"
                      class="sort-buttons">
                      <button class="svg-button" v-if="isDescending">
                        <svg class="svg-icon"
                          style="width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden;"
                          viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M573.056 752l308.8-404.608A76.8 76.8 0 0 0 820.736 224H203.232a76.8 76.8 0 0 0-61.056 123.392l308.8 404.608a76.8 76.8 0 0 0 122.08 0z" />
                        </svg>
                      </button>
                      <button class="svg-button" v-if="!isDescending">
                        <svg class="svg-icon"
                          style="width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden;"
                          viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M573.056 272l308.8 404.608A76.8 76.8 0 0 1 820.736 800H203.232a76.8 76.8 0 0 1-61.056-123.392L450.976 272a76.8 76.8 0 0 1 122.08 0z" />
                        </svg>
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr v-if="noRecordFound">
                  <td class="h4" colspan="15">No records found !</td>
                </tr>
                <tr v-else-if="reportTransactions && reportTransactions.transactions"
                  v-for="(transaction, index) in reportTransactions.transactions" :key="getUniqueIDValue(transaction)"
                  @click="handleRowClick($event, getUniqueIDValue(transaction), index)" role="button"
                  :class="{ 'custom-selected-row': effectiveSelections.includes(getUniqueIDValue(transaction)) }">
                  <td v-if="isMultiSelectionAllowed" class="align-middle">
                    <input type="checkbox" :checked="effectiveSelections.includes(getUniqueIDValue(transaction))"
                      @click.stop="collateRequestIDs(getUniqueIDValue(transaction))" />
                  </td>

                  <td v-for="column in selectedConfigs" :key="column.name"
                    :style="getTextAlignmentStyle(transaction, column)" v-bind="column.name === 'fileName' && transaction.usecaseNames != null && !isSingleUsecase(transaction.usecaseNames) ? {
                      'data-bs-toggle': 'popover',
                      'data-bs-html': 'true',
                      'data-bs-title': 'Usecase Names',
                      'data-bs-content': getUsecaseNames(transaction.usecaseNames)
                    } : {}" @mouseenter="column.name === 'fileName' && showPopover($event)"
                    @mouseleave="column.name === 'fileName' && hidePopover($event)">

                    <template v-if="column.name === 'accelatorStatus'">
                      <div>
                        <span v-for="status in getStatusColumns(transaction)" :key="status.accuracy"
                          class="status-container" v-tooltip="`${status.name} (${status.accuracyValue}%)`">
                          <svg class="progress-circle" viewBox="0 0 36 36">
                            <path class="circle-bg" d="M18 2.0845
                                     a 15.9155 15.9155 0 0 1 0 31.831
                                     a 15.9155 15.9155 0 0 1 0 -31.831" />
                            <path class="circle" :class="status.cssClass" :stroke-dasharray="status.strokeDasharray" d="M18 2.0845
                                     a 15.9155 15.9155 0 0 1 0 31.831
                                     a 15.9155 15.9155 0 0 1 0 -31.831" />
                          </svg>
                          <!-- a: left-click = in-app nav, right-click = open in new tab -->
                          <a :href="getStatusRouteUrl(transaction, status)" target="_blank" rel="noopener noreferrer"
                            @click.prevent="handleStatusIconClick(transaction, status)">
                            <img :src="status.icon" alt="status" :class="['status-icon',
                              {
                                'xslticon': status.icon.includes('xslticon.png'),
                                'kafka-icon': status.icon.includes('kafka-logo.png'),
                                'connector-icon': status.icon.includes('Connector.png'),
                                'api-icon': status.icon.includes('Api.png'),
                                // 'orchestration-icon': status.icon.includes('orchestration5.png'),
                                'not-applicable': status.statusValue === 'Not Applicable',
                                'failed': status.statusValue === 'Failed',
                                'in-progress': status.statusValue === 'In Progress'
                              }]"
                              :style="status.icon.includes('xslt') || status.icon.includes('kafka') || status.icon.includes('Connector') || status.icon.includes('Api') ? 'width: 30px; height: 30px;' : 'width: 25px; height: 25px;'" />
                              <!-- :style="status.icon.includes('xslt') || status.icon.includes('kafka') || status.icon.includes('Connector') || status.icon.includes('Api') || status.icon.includes('Orchestration') ? 'width: 30px; height: 30px;' : 'width: 25px; height: 25px;'" /> -->
                          </a>
                        </span>
                      </div>
                    </template>
                    <template v-else-if="checkIfActionable(transaction, column)">
                      <a v-tooltip="computeAccuracy(transaction, column)"
                        :class="getStylesForStatus(transaction, column, isActionable = true)"
                        @click="handleActionableColumns(transaction, column)">{{ getTableData(transaction, column) }}
                        <!-- <span v-if="transaction.schemaAccuracy" class="accuracy">{{ transaction.schemaAccuracy }}</span> -->
                      </a>
                    </template>
                    <template v-else-if="checkIfDateColumn(column)">
                      <div v-tooltip="computeDateAndTimestamp(transaction, column)">{{ getTableData(transaction, column)
                      }}</div>
                    </template>
                    <template v-else-if="checkIfEditable(column)">
                      <div :class="[getStylesForStatus(transaction, column, isActionable = false)]">
                        <select v-if="isEditing(getUniqueIDValue(transaction), column)"
                          v-model="transaction[column.name]" @change="trackChanges(transaction, column)">
                          <option v-for="option in column.dropdownOptions"
                            :key="resolveDropDownSelectionKey(option, column)"
                            :value="resolveDropDownSelectionKey(option, column)">{{ option }}
                          </option>
                          <div class="select-arrow">&#9660;</div>
                        </select>
                        <div v-else>{{ getTableData(transaction, column) }}
                          <img src="../../assets/icons/editable.svg" @click="startEditing(transaction, column)" alt="Edit"
                            class="pointer">
                        </div>
                      </div>

                    </template>

                    <template v-else>
                      <div v-tooltip="computeAccuracy(transaction, column)"
                        :style="getTextOverflowStyle(transaction, column)"
                        :class="[getStylesForStatus(transaction, column, isActionable = false), getSingleRecordCenterClass(transaction, column)]"
                        @mouseenter="handleMouseEnterForEllipsedText($event, transaction, column)"
                        @mouseleave="hidleEllipsedTextTooltip($event)">{{
                          getTableData(transaction,
                            column) }}
                        <!-- <span v-if="transaction.schemaAccuracy" class="accuracy">{{ transaction.schemaAccuracy }}</span> -->
                      </div>
                    </template>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <!--Pagination starts-->
      <div class="pagination-bar row" v-if="!noRecordFound">
        <Pagination :totalPages="totalPages" :perPage="pageSize" :currentPage="currentPage" :totalRecords="totalRecords"
          @pagechanged="onPageChange" @recordCount="onRecordChange" @clearSelection="handleClearSelection" />
      </div>
    </div>
  </div>
  <FooterView />
</template>


<script>
import Loading from '../Loading.vue';
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { redirect } from "@/utils/routerUtils.js";
import { changeFileExtension } from "@/utils/util.js";
import {
  action,
  actionLabel,
  elementsToRemoveFromArray,
  invalidBEColumns,
  supportingColumns,
  CONVERSION_STATUS,
  STATUS_COLUMNS,
  DATE_COLUMNS,
  ACCURACY_COLUMNS_STATUS_MAP,
  pageViews,
  type,
  user,
  api_mode,
  GRID_ACTION_DATA_ELEMENTS,
  ROUTER_PARAMS_GRID_FILTER_MAP,
  role,
  EDITABLE_GRID_CHANGES_COLUMNS,
  EDITABLE_GRID_ACTIONS,
} from "../../utils/util.js";
import ConfirmModal from "../ConfirmModal.vue";
import { useSortStore, useTableColumnStore } from "../../store/sort.js"
import { usePaginationStore } from "../../store/paginationStore.js"
import { getCookie } from "../../store/cookie.js";
import { useUploadStore } from "../../store/fileUpload.js";
import { makeOpearationRequest, getTitle } from "@/services/apiServices";
import { getSessionItem, setSessionItem, removeSessionItem } from "../../store/session.js";
import { mock_response } from "../../utils/mock.js";
import PopupYAML from "../PopupYAML.vue";
import Pagination from '../Pagination.vue';
import CalculateComplexityPopup from "../CalculateComplexityPopup.vue";
import TransformationFactoryPopup from "../TransformationFactoryPopup.vue";
import FooterView from "@/views/FooterView.vue";
import { Popover } from 'bootstrap'
let SELECT_AT_LEAST_ONE_ITEM = 'Select at least one item';

export default {
  name: "ReportTemplate",
  props: ["tableProps", "projectParamId", "xslParamId", "xmlParamId", "jmsParamId", "xsdParamId", "configParamId", "mapperParamId", "apiParamId"],
  emits: ["editableGridUpdated", 'toggleTabs'],
  data() {
    return {
      popupData: {
        viewContent: [],
        fileName: ""
      },
      lastSelectedIndex: null,
      projectName: "",
      popupCommonData: {},
      popupFileData: [],
      popUpLoading: true,
      currentPageName: "",
      showPopup: false,
      sortColumn: this.getDefaultSortColumn(),
      hoveredColumn: "",
      isDescending: true,
      noRecordFound: false,
      searchName: "",
      searchConcept: "All Categories",
      searchQuery: "",
      tableConfigs: {},
      selectedConfigs: {},
      showCalcPopup: false,
      columns: {
        default: {},
        sort: {},
        search: {}
      },
      files: [],
      filterSortColumn: this.tableProps.defaultSortColumn || "requestDate",
      filterSortOrder: this.tableProps.defaultSortOrder || "desc",
      reportTransactions: { transactions: [] },
      userId: getCookie(user.id),
      loading: true,
      selectedFilter: ["ok", "new", "fail", "in-prog", "NA", "*"],
      refreshReport: {
        interval: 5000,
        autoRefresh: false,
        isAutoRefresh: false,
      },
      selectedColumns: [],
      popup: {},
      selectedReqsForBulkOps: [],
      backupSelections: [],
      currentPage: 1,
      pageSize: 20,
      totalPages: 5, //Just initial value. will be overridden in search() api call
      isMultiSelectionAllowed: false,
      uploadStore: useUploadStore(),
      ellipsesdTextoolTip: null,
      selectAllCheckboxes: false,
      // Add this new property to track selections per page
      selectedReqsByPage: {},
      changes: [],
      editingId: null,
      originalValues: {},
      refinedEditableGridViewColumns: [],
      refinedEditableGridUpdatesToBeEmitted: {},
      totalRecords: 0,
      stateFilter: ["true", "false", "*"],
      states: [{ "name": "true", "label": "In-Active" }, { "name": "false", "label": "Active" }],
      isGridVisible: true,
      showTransformationFactoryPopup: false,
      useCaseData: [],
      showUseCasePopup: false,
      pendingDownloadRequests: [],
      isSelectAllUsed: false,
      allSelectedReqs: new Set(), // Track all selected IDs globally
    };
  },
  components: {
    ConfirmModal,
    PopupYAML,
    Pagination,
    CalculateComplexityPopup,
    TransformationFactoryPopup,
    Loading,
    FooterView
  },

  computed: {
    effectiveSelections() {
      if (this.showTransformationFactoryPopup && this.backupSelections.length > 0) {
        return this.backupSelections;
      }
      return this.selectedReqsForBulkOps;
    },
    routerParams() {
      return this.$route.params;
    },
    requestId() {
      // return Store.getters.getRequestId;
      return getSessionItem("requestId");
    },
    computeDateAndTimestamp() {
      return (transaction, column) => {
        return this.convertToLocalTimeAndFormat(transaction[column.name], true);
      }
    },
    computeAccuracy() {
      return (transaction, column) => {
        return this.checkReturnAccuracyValue(transaction, column);
      }
    },
    uploadComplete() {
      return this.uploadStore.uploadComplete;
    },
    refinedChanges() {
      const result = this.changes.map(change => {
        const processedObject = {};
        Object.keys(this.refinedEditableGridViewColumns).forEach(key => {
          const columnMetadata = this.tableConfigs.filter((item) => item.name === key).reduce((acc, curr) => { return curr });
          if (key in change) {
            processedObject[this.refinedEditableGridViewColumns[key]] = (STATUS_COLUMNS.includes(key) && change.hasOwnProperty(key)) ? CONVERSION_STATUS.getByValue(change[key]).name : change[key];
          }
          if (columnMetadata && columnMetadata.traceable) {
            const currentKey = `current_${key}`;
            if (currentKey in change) {
              processedObject[`Prior ${this.refinedEditableGridViewColumns[key]}`] = (STATUS_COLUMNS.includes(key) && change.hasOwnProperty(key)) ? CONVERSION_STATUS.getByValue(change[currentKey]).name : change[currentKey];
            } else {
              processedObject[`Prior ${this.refinedEditableGridViewColumns[key]}`] = (STATUS_COLUMNS.includes(key) && change.hasOwnProperty(key)) ? CONVERSION_STATUS.getByValue(change[currentKey]).name : change[key];
            }
          }
        });
        return processedObject;
      });
      return result;
    },
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  async mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.getSetConfig();
    this.getPagination();
    this.selectedSort();
    let isViewUpdated = this.tableStore.getTableState(this.$route.name);
    isViewUpdated ? this.copyPropsFromSession() : this.copyProps();
    this.search();
  },
  unmounted() {
    clearInterval(this.refreshReport.isAutoRefresh);
  },
  setup() {
    const sortStore = useSortStore()
    const tableStore = useTableColumnStore()
    const paginationStore = usePaginationStore()
    return { sortStore, tableStore, paginationStore, pageViews, type };
  },

  watch: {
    uploadComplete(uploadStats) {
      if (uploadStats) {
        this.refresh();
        this.search();
        this.uploadStore.setUploadComplete(false);
      }
    },
    selectedReqsForBulkOps: {
      handler(newVal) {
        // Keep selectAllCheckboxes in sync with selection
        if (
          this.reportTransactions &&
          this.reportTransactions.transactions &&
          this.reportTransactions.transactions.length > 0 && this.reportTransactions.transactions.length === newVal.length
        ) {
          this.selectAllCheckboxes =
            newVal.length === this.reportTransactions.transactions.length;
        } else {
          this.selectAllCheckboxes = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    showPopover(e) {
      try {
        const el = e.currentTarget;
        if (!el) return;

        // Dispose any existing popover on the element
        const existing = Popover.getInstance(el);
        if (existing) existing.dispose();

        // Create new popover
        const pop = new Popover(el, {
          trigger: 'manual',
          container: 'body',
          html: true,
          placement: 'top',
        });
        pop.show();

        // Adjust width after showing
        const popoverEl = document.querySelector('.popover');
        if (popoverEl) {
          popoverEl.style.maxWidth = '500px';   // adjust width
          popoverEl.style.whiteSpace = 'normal'; // allow wrapping
        }
      } catch (error) {
        console.warn('Popover error (show):', error);
      }
    },

    hidePopover(e) {
      try {
        const el = e.currentTarget;
        if (!el) return;

        const pop = Popover.getInstance(el);
        if (pop) pop.hide();
      } catch (error) {
        console.warn('Popover error (hide):', error);
      }
    },

    handleClickOutside(event) {
      const excludedTags = new Set(["button", "input"]);

      if (excludedTags.has(event.target.tagName.toLowerCase())) {
        return;
      }

      if (!this.$refs.requestTable?.contains(event.target)) {
        this.selectedReqsForBulkOps = [];
      }
    },
    getPagination() {
      const paginationStore = this.paginationStore.getPaginationState(this.$route.name);
      if (paginationStore) {
        this.currentPage = paginationStore.currentPage;
        this.pageSize = paginationStore.pageSize;
      }
    },
    isSortable(column) {
      return column?.isSortable !== false;
    },
    toggleTabs() {
      this.$emit('toggleTabs');
    },
    getDefaultSortColumn() {
      const colOrder = this.tableProps.configs.find(item => item.order === 1);
      return colOrder ? colOrder.name : (this.tableProps.configs[0] ? this.tableProps.configs[0].name : '');
    },
    setShowPop(value) {
      this.showPopup = value;
    },
    collateRequestIDs(requestId) {
      if (this.$parent.$options.name == pageViews.TRASHVIEW) {
        this.selectedReqsForBulkOps = [requestId];
        this.allSelectedReqs = new Set([requestId]);
      } else {
        const index = this.selectedReqsForBulkOps.indexOf(requestId);
        if (index > -1) {
          this.selectedReqsForBulkOps.splice(index, 1);
          this.allSelectedReqs.delete(requestId);
        } else {
          this.isSelectAllUsed = false;
          this.selectedReqsForBulkOps.push(requestId);
          this.allSelectedReqs.add(requestId);
        }
      }
    },
    updateSelectAllCheckboxes() {
      // Update per-page selection state
      const pageKey = this.currentPage;
      if (!this.selectedReqsByPage) this.selectedReqsByPage = {};
      this.selectedReqsByPage[pageKey] = [...this.selectedReqsForBulkOps];

      this.selectAllCheckboxes = (
        this.reportTransactions &&
        this.reportTransactions.transactions &&
        this.reportTransactions.transactions.length > 0 &&
        this.reportTransactions.transactions.length === this.selectedReqsForBulkOps.length
      );
    },
    toggleSelectAllCheckboxes() {
      const pageKey = this.currentPage;
      if (this.selectAllCheckboxes) {
        // Track that "select all" was used
        this.isSelectAllUsed = true;
        // Select all visible records and add to global selection
        const ids = this.reportTransactions.transactions.map(txn => this.getUniqueIDValue(txn));
        this.selectedReqsForBulkOps = ids;
        ids.forEach(id => this.allSelectedReqs.add(id));
      } else {
        // When deselecting all, reset the flag
        this.isSelectAllUsed = false;
        // Deselect all visible records, but keep others selected
        const ids = this.reportTransactions.transactions.map(txn => this.getUniqueIDValue(txn));
        this.selectedReqsForBulkOps = [];
        ids.forEach(id => this.allSelectedReqs.delete(id));
      }
      // Save selection for this page
      this.selectedReqsByPage[pageKey] = [...this.selectedReqsForBulkOps];
    },
    setType(type) {
      setSessionItem("type", type);
    },
    checkReturnAccuracyValue(transaction, column) {
      let tooltip_suffix = "% accurate"
      if (STATUS_COLUMNS.includes(column.name) && transaction.hasOwnProperty(ACCURACY_COLUMNS_STATUS_MAP[column.name])) {
        return transaction[ACCURACY_COLUMNS_STATUS_MAP[column.name]] + tooltip_suffix;
      }
    },
    checkIfDateColumn(column) {
      if (DATE_COLUMNS.includes(column.name))
        return true;
      return false;
    },
    checkIfEditable(column) {
      return (column.isEditable && column.dropdownOptions);
    },
    checkIfActionable(transaction, column) {
      const actionableStatus = [CONVERSION_STATUS.OK.value];
      /* const actionableStatus = [CONVERSION_STATUS.OK.value, CONVERSION_STATUS.PROGRESS.value, CONVERSION_STATUS.NA.value, CONVERSION_STATUS.FAIL.value]; */
      if (column.actionable && column.routeTo)
        if (STATUS_COLUMNS.includes(column.name) && transaction.hasOwnProperty(column.name) && actionableStatus.includes(transaction[column.name]))
          return true;
      return false;
    },
    getStylesForStatus(transaction, column, isActionable) {
      const allStatus = [CONVERSION_STATUS.OK.value, CONVERSION_STATUS.PROGRESS.value, CONVERSION_STATUS.NA.value, CONVERSION_STATUS.FAIL.value, CONVERSION_STATUS.NEW.value, CONVERSION_STATUS.TRUE.value, CONVERSION_STATUS.FALSE.value];
      if (STATUS_COLUMNS.includes(column.name) && transaction.hasOwnProperty(column.name) && allStatus.includes((transaction[column.name].toString()))) {
        if (CONVERSION_STATUS.getByValue(transaction[column.name]) == CONVERSION_STATUS.OK) {
          return isActionable ? "text-success actionable" : "text-success";
        } else if (CONVERSION_STATUS.getByValue(transaction[column.name]) == CONVERSION_STATUS.PROGRESS) {
          return isActionable ? "text-in-progress actionable blink" : "text-in-progress blink";
        } else if (CONVERSION_STATUS.getByValue(transaction[column.name]) == CONVERSION_STATUS.NA) {
          return isActionable ? "text-not-applicable actionable" : "text-not-applicable";
        } else if (CONVERSION_STATUS.getByValue(transaction[column.name]) == CONVERSION_STATUS.FAIL) {
          return isActionable ? "text-danger actionable" : "text-danger";
        } else if (CONVERSION_STATUS.getByValue(transaction[column.name]) == CONVERSION_STATUS.NEW) {
          return isActionable ? "text-new-status actionable" : "text-new-status";
        } else if (CONVERSION_STATUS.getByValue(transaction[column.name]) == CONVERSION_STATUS.TRUE) {
          return isActionable ? "text-danger actionable" : "text-danger";
        } else if (CONVERSION_STATUS.getByValue(transaction[column.name]) == CONVERSION_STATUS.FALSE) {
          return isActionable ? "text-success actionable" : "text-success";
        }
      }
      return;
    },
    getSingleRecordCenterClass(transaction, column) {
      if (column.name === 'customFunctionList' &&
        this.reportTransactions &&
        this.reportTransactions.transactions &&
        this.reportTransactions.transactions.length === 1) {
        const data = this.getTableData(transaction, column);
        if (data && data !== '-' && !data.includes(',')) {
          return 'single-record-center';
        }
      }
      return '';
    },
    getTextAlignmentStyle(transaction, column) {
      let myStyle;

      if (column.textAlign && column.textOverflowStyle) {
        myStyle = `text-align:${column.textAlign};white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 250px;`;
      } else if (column.textAlign) {
        myStyle = `text-align:${column.textAlign};`;
      } else if (column.textOverflowStyle) {
        myStyle = `white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 250px;`;
      }

      if (String(transaction.usecaseNames).split(',').length > 1 && column.name === 'fileName') {
        return `text-decoration: underline green;${myStyle}`
      } else {
        return myStyle
      }
      return;
    },
    getTextOverflowStyle(transaction, column) {
      return column.textOverflowStyle ? `white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; display: inline-block` : "";
    },
    handleMouseEnterForEllipsedText(event, transaction, column) {
      const target = event.target;
      if (column.textOverflowStyle && (target.scrollWidth > target.clientWidth)) {
        const textContent = target.innerText;
        const rect = target.getBoundingClientRect();
        this.ellipsesdTextoolTip = document.createElement('div');
        this.ellipsesdTextoolTip.className = 'custom-ellipsed-text-tooltip';
        this.ellipsesdTextoolTip.innerText = textContent;
        document.body.appendChild(this.ellipsesdTextoolTip);
        this.ellipsesdTextoolTip.style.top = `${rect.top + window.scrollY - this.ellipsesdTextoolTip.offsetHeight - 5}px`;
        this.ellipsesdTextoolTip.style.left = `${rect.left + window.scrollX}px`;
      }
    },
    hidleEllipsedTextTooltip(event) {
      if (this.ellipsesdTextoolTip) {
        document.body.removeChild(this.ellipsesdTextoolTip);
        this.ellipsesdTextoolTip = null;
      }
    },
    checkToShowTrash(viewName) {
      if (viewName == pageViews.ALLINONE_ACC_VIEW)
        return true;
      return false;
    },
    setInitialPageToOne(view) {
      this.paginationStore.savePaginationState(view, this.pageSize, 1);
    },
    handleActionableColumns(transaction, column) {
      this.setInitialPageToOne(pageViews.KAFKACONFIGGENERATORVIEW);
      this.setInitialPageToOne(pageViews.SCHEMACONVERTERVIEW);
      this.setInitialPageToOne(pageViews.CONVERTERVIEW);
      this.setInitialPageToOne(pageViews.CONNECTOR_CONFIG_GENERATOR_VIEW);
      this.setInitialPageToOne(pageViews.MAPPERVIEW);
      this.setInitialPageToOne(pageViews.APIVIEW);
      this.redirectView(column.routeTo, transaction);
    },
    handleUseCaseClick(transaction) {
      if (transaction.usecaseNames && transaction.usecaseNames.length > 0) {
        // Handle both array and string formats
        let useCases = [];
        if (Array.isArray(transaction.usecaseNames)) {
          useCases = transaction.usecaseNames;
        } else if (typeof transaction.usecaseNames === 'string') {
          useCases = transaction.usecaseNames.split(',').map(uc => uc.trim()).filter(Boolean);
        }

        this.useCaseData = useCases.map(uc => ({
          useCase: uc,
          usecaseIds: transaction.usecaseIds || 'N/A'
        }));
      } else {
        this.useCaseData = [];
      }
      this.showUseCasePopup = true;
    },
    isDownloadToBeDisabled(transaction) {
      const matchingStatusColumns = STATUS_COLUMNS.filter(key => transaction.hasOwnProperty(key));
      let statusToBeChecked = [];
      if ([type.KAFKA, type.PROJECT].includes(this.tableProps.type)) {
        statusToBeChecked = [CONVERSION_STATUS.OK.value];
      } else {
        statusToBeChecked = [CONVERSION_STATUS.OK.value, CONVERSION_STATUS.NA.value, CONVERSION_STATUS.FAIL.value, CONVERSION_STATUS.PROGRESS.value];
      }
      const atleastOnePassed = matchingStatusColumns.map(key => transaction[key]).some(element => statusToBeChecked.includes(element));
      return !atleastOnePassed;
    },
    isViewToBeDisabled(transaction) {
      const matchingStatusColumns = STATUS_COLUMNS.filter(key => transaction.hasOwnProperty(key));
      let statusToBeChecked = [];
      if ([type.KAFKA].includes(this.tableProps.type)) {
        statusToBeChecked = [CONVERSION_STATUS.OK.value];
      } else {
        statusToBeChecked = [CONVERSION_STATUS.OK.value, CONVERSION_STATUS.NA.value, CONVERSION_STATUS.FAIL.value, CONVERSION_STATUS.PROGRESS.value];
      }
      const atleastOnePassed = matchingStatusColumns.map(key => transaction[key]).some(element => statusToBeChecked.includes(element));
      return !atleastOnePassed;
    },
    isViewMapperToBeDisabled(transaction) {
      const matchingStatusColumns = STATUS_COLUMNS.filter(key => transaction.hasOwnProperty(key));
      let statusToBeChecked = [];
      if ([type.MAPPER].includes(this.tableProps.type)) {
        statusToBeChecked = [CONVERSION_STATUS.OK.value];
      } else {
        statusToBeChecked = [CONVERSION_STATUS.OK.value, CONVERSION_STATUS.NA.value, CONVERSION_STATUS.FAIL.value, CONVERSION_STATUS.PROGRESS.value];
      }
      const atleastOnePassed = matchingStatusColumns.map(key => transaction[key]).some(element => statusToBeChecked.includes(element));
      return !atleastOnePassed;
    },
    isXMLTransformToBeDisabled(transaction) {
      const matchingStatusColumns = STATUS_COLUMNS.filter(key => transaction.hasOwnProperty(key));
      let statusToBeChecked = [CONVERSION_STATUS.OK.value, CONVERSION_STATUS.NA.value, CONVERSION_STATUS.FAIL.value, CONVERSION_STATUS.PROGRESS.value];
      const atleastOnePassed = matchingStatusColumns.map(key => transaction[key]).some(element => statusToBeChecked.includes(element));
      return !atleastOnePassed;
    },
    handleInputs(event) {
      if (!event.target.value) {
        this.search();
      }
    },

    getSetConfig() {
      //const config = require("../../public/config.json");
      this.refreshReport.autoRefresh = window.acclConfigs.AUTO_REFRESH;
      this.refreshReport.interval = window.acclConfigs.REFRESH_INTERVAL;
    },

    selectedSort() {
      const savedState = this.sortStore.getSortState(this.$route.name);
      if (savedState) {
        this.filterSortOrder = savedState.sortOrder;
        this.filterSortColumn = savedState.sortColumn;
        this.sortColumn = savedState.sortColumn;
        this.isDescending = savedState.sortOrder === 'desc' ? true : false;
      } else {
        this.sortColumn = this.getDefaultSortColumn();
      }
    },

    sort(header, index) {
      this.currentPageName = this.$route.name;

      if (this.isDescending) {
        this.sortAscending(header, index);
      } else {
        this.sortDescending(header, index);
      }
    },
    clearSort() {
      this.sortColumn = this.getDefaultSortColumn();
      this.filterSortColumn = this.tableProps.defaultSortColumn ? this.tableProps.defaultSortColumn : "requestDate";
      this.filterSortOrder = this.tableProps.defaultSortOrder ? this.tableProps.defaultSortOrder : "desc";
    },

    sortAscending(header, index) {
      this.sortColumn = header.name;
      this.isDescending = false;
      this.filterSortOrder = "asc";
      this.handleSortByChange(header);
      this.sortStore.saveSortState(this.currentPageName, this.filterSortOrder, this.filterSortColumn, index);
    },

    sortDescending(header, index) {
      this.sortColumn = header.name;
      this.isDescending = true;
      this.filterSortOrder = "desc";
      this.handleSortByChange(header);
      this.sortStore.saveSortState(this.currentPageName, this.filterSortOrder, this.filterSortColumn, index);
    },
    clearFilters() {
      this.selectedFilter = ["*", "ok", "new", "fail", "in-prog", "NA"];
      this.stateFilter = ["true", "false", "*"];
      this.copyProps();
      this.searchName = "";
      this.searchConcept = "All Categories";
      this.searchQuery = "";
      this.clearSort();
      this.clearUpdatedViews();
      this.search();
    },
    clearUpdatedViews() {
      removeSessionItem(this.tableProps.type + '_columns');
      removeSessionItem(this.tableProps.type + '_view_updated');
    },
    setSearchFilter(filter) {
      if (filter == "All Categories") {
        this.searchConcept = filter;
      } else {
        this.searchConcept = filter.label;
      }
      this.searchName = filter.name;
    },
    openModalFromCalc(data) {
      this.popup = data
      this.openModal()
    },
    openModal() {
      this.$refs.openModalBox.openModal();
    },
    resolveDropDownSelectionKey(selectedValue, cloumn) {
      if (STATUS_COLUMNS.includes(cloumn.name)) {
        let dropdownKey = CONVERSION_STATUS.getByName(selectedValue);
        return dropdownKey.value;
      } else {
        return selectedValue;
      }
    },

    isSingleUsecase(usecaseNames) {
      if (String(usecaseNames).split(',').length == 1) {
        return true;
      } else {
        return false;
      }
    },

    getUsecaseNames(usecaseNames) {

      if (!usecaseNames) return 'No Usecase Available'

      return String(usecaseNames)
        .split(',')
        .map((u, i) => i + 1 + ". " + u.trim())
        .join('<br><br>')
    },
    getTableData(record, column) {

      if (column.formatter) {
        return column.formatter(record[column.name]);
      }

      if (column.name === "accelatorStatus") {
        return this.getStatusColumns(record).map(({ icon, statusValue, accuracyValue }) => {
          return `<img src="${icon}" alt="status" style="width: 25px; height: 25px;" /> - ${statusValue} (${accuracyValue}%)`;
        }).join(", ");
      }

      let value = record[column.name];
      if (STATUS_COLUMNS.includes(column.name) && record.hasOwnProperty(column.name)) {
        let conv_status = CONVERSION_STATUS.getByValue(record[column.name]);
        value = conv_status.name;
      }

      if (column.type == "date") {
        value = this.convertToLocalTimeAndFormat(value, false);
      }
      else if (column.suffix && value != undefined) {
        value = value + column.suffix;
      } else if (value == undefined) {
        value = '-';
      }

      return value;
    },

    setValuesToSession(componentType, userId, requestId, convertedFileName) {
      setSessionItem("userId", userId);
      componentType === type.XML ? setSessionItem("xmlrequestId", requestId) : setSessionItem("xslRequestIds", requestId);
      setSessionItem("convertedFileName", convertedFileName);
      setSessionItem("componentType", componentType);
      if (componentType === type.XSL) {
        setSessionItem("xslFileName", convertedFileName);
      }
    },

    copyProps() {
      this.tableConfigs = [...this.tableProps.configs].sort(
        (a, b) => a.order - b.order
      );
      this.addUserColumnIfAdmin();
      this.selectedConfigs = this.tableConfigs.filter(
        (column) => column.defaultSelected
      );

      this.selectedColumns = this.selectedConfigs.map((column) => column.name);
      this.columns.search = this.tableConfigs
        .filter((item) => item.search != false)
        .map(({ name, label }) => ({ name, label }));

      this.isMultiSelectionAllowed = this.tableProps.isMultiSelectionAllowed;
    },

    copyPropsFromSession() {
      this.tableConfigs = [...this.tableProps.configs].sort(
        (a, b) => a.order - b.order
      );
      this.addUserColumnIfAdmin();
      this.selectedConfigs = this.tableStore.getTableState(this.$route.name)
      this.selectedColumns = this.selectedConfigs.map((column) => column.name);

      if (this.selectedColumns?.length ===
        this.tableConfigs?.length
      ) {
        this.selectedColumns.push("*");
      }

      this.columns.search = this.tableConfigs
        .filter((item) => item.search != false)
        .map(({ name, label }) => ({ name, label }));

      this.isMultiSelectionAllowed = this.tableProps.isMultiSelectionAllowed;
    },
    addUserColumnIfAdmin() {
      let userRole = getCookie(user.role)
      if ([role.admin, role.superadmin].includes(userRole) &&
        this.tableProps.type != type.USER_ROLES &&
        this.tableProps.type != type.ORCHESTRATION) {
        let userObj = {
          name: "userId",
          label: "User ID",
          order: 0,
          defaultSelected: true,
          textAlign: "left",
        };
        this.tableConfigs.unshift(userObj)
      }
    },
    handleSortByChange(header) {
      this.filterSortColumn = header.name;
      this.search();
    },
    convertToLocalTimeAndFormat(databaseDateString, appendTimeStamp) {
      // Handle null, undefined, or empty values
      if (!databaseDateString || databaseDateString === null || databaseDateString === undefined) {
        return "-";
      }
      
      const dateObject = new Date(databaseDateString);
      
      // Check if the date is invalid
      if (isNaN(dateObject.getTime())) {
        return "-";
      }

      // Convert to local time
      const localDateObject = new Date(
        dateObject.getTime() - dateObject.getTimezoneOffset() * 60000
      );
      return this.formatDate(localDateObject, appendTimeStamp);
    },
    formatDate(dateTimeString, appendTimeStamp) {
      let dateDelimiter = "/";
      const dateObject = new Date(dateTimeString);
      let formattedDate = `${this.formatTwoDigits(
        dateObject.getMonth() + 1
      )}${dateDelimiter}${this.formatTwoDigits(
        dateObject.getDate()
      )}${dateDelimiter}${dateObject.getFullYear()}`;

      if (appendTimeStamp) {
        formattedDate = formattedDate + ` ${this.formatTwoDigits(
          dateObject.getHours()
        )}:${this.formatTwoDigits(
          dateObject.getMinutes()
        )}:${this.formatTwoDigits(dateObject.getSeconds())}`;
      }
      return formattedDate;
    },
    formatTwoDigits(value) {
      return value.toString().padStart(2, "0");
    },
    confirmDelete(incomingData) {
      let data = {
        userId: incomingData.userId,
        action: action.DELETE,
        type: incomingData.fileType,
        requestId: [incomingData.requestId]
      };
      this.setConfirmModalValues(
        `Are you sure you want to delete ?`,
        incomingData.fileName,
        "Delete",
        "Cancel",
        data
      );
      this.openModal();
    },
    confirmDeleteAll(incomingData) {

      const filenames = this.reportTransactions.transactions
        .filter(item => incomingData.includes(item.projectId)) // Find objects with matching IDs
        .map(item => item.fileName);          // Extract filenames

      let data = {
        userId: getCookie(user.id),
        action: action.DELETE,
        type: this.tableProps.type,
        requestId: incomingData
      };
      this.setConfirmModalValues(
        `Are you sure you want to delete the following file(s) ?`,
        filenames,
        "Delete",
        "Cancel",
        data
      );
      this.openModal();
    },
    setConfirmModalValues(
      title,
      body,
      actionLabel,
      secondaryActionLabel,
      data
    ) {
      const confirmModalData = {
        title,
        body,
        actionLabel,
        secondaryActionLabel,
        data,
      };
      this.popup = { ...confirmModalData };
    },

    handleColumnChange(value) {
      if (value === "*") {
        if (this.selectedColumns?.length === this.tableConfigs?.length) {
          this.selectedColumns = this.tableConfigs
            .filter((column) => column.checked)
            .map((item) => item.name);
        } else if (
          this.selectedColumns?.length <=
          this.tableConfigs?.length - 2
        ) {
          this.selectedColumns = this.tableConfigs.map(
            (column) => column?.name
          );
          this.selectedColumns.push("*");
        }
      }
      if (value !== "*") {
        this.selectedColumns = this.selectedColumns.filter(
          (selectedColumn) => selectedColumn !== "*"
        );
      }

      this.selectedValidColumns = this.selectedColumns.filter(
        (column) => column !== "*"
      );

      this.selectedConfigs = this.tableConfigs.filter((column) =>
        this.selectedColumns.includes(column.name)
      );
      this.tableStore.saveTableState(this.$route.name, this.selectedConfigs);
      this.search();
    },
    handleStateChange(value) {
      if (value === "*") {
        if (this.stateFilter.length === 0) {
          this.stateFilter.push("false");
        } else if (this.stateFilter?.length === this.states?.length && !this.stateFilter.includes("*")) {
          this.stateFilter = this.states
            .filter((item) => item.name == "false")
            .map((item) => item.name);
        } else {
          this.stateFilter = this.states?.map((status) => status.name);
          this.stateFilter.push("*");
        }
      } else {
        this.stateFilter = this.stateFilter.filter(
          (statusFilter) => statusFilter !== "*"
        );
        if (this.stateFilter?.length === this.states?.length && !this.stateFilter.includes("*")) {
          this.stateFilter.push("*");
        }
      }
      this.search();
    },
    handleStatusChange(value) {
      if (value === "*") {
        if (this.selectedFilter.length === 0) {
          this.selectedFilter.push("ok");
        }

        if (this.selectedFilter?.length === this.$statuses?.length) {
          this.selectedFilter = this.$statuses
            .filter((item) => item.name == "ok")
            .map((item) => item.name);
        } else {
          this.selectedFilter = this.$statuses?.map((status) => status.name);
          this.selectedFilter.push("*");
        }
      } else {
        this.selectedFilter = this.selectedFilter.filter(
          (statusFilter) => statusFilter !== "*"
        );
        if (this.selectedFilter?.length === this.$statuses?.length && !this.selectedFilter.includes("*")) {
          this.selectedFilter.push("*");
        }
      }
      this.search();
    },
    hardShowLoading(message) {
      return toast.loading(message, {
        autoClose: false,
        closeOnClick: false,
      });
    },
    showSuccess(message) {
      return toast.success(message, {
        autoClose: 3000,
      });
    },
    showError(message) {
      toast.error(message, {
        autoClose: 3000,
      });
    },

    handlePrimaryAction(data) {

      if (data.action) {
        if (data.action === action.DELETE) {
          this.deleteRecord(data);
        } else if (data.action === action.REPLACE) {
          this.restoreRecord(data);
        } else if (data.action === action.REMOVE_CALC_ROW) {
          this.$refs.removeRowRef.removeRow(data);
        }
      }


    },
    async bulkDelete(reqIdArr) {
      this.confirmDeleteAll(reqIdArr);
    },
    async deleteRecord(data) {
      let body = {
        userId: data.userId,
        type: data.type,
        requestIds: data.requestId
      };

      try {
        const response = await makeOpearationRequest(this.$acclConfigs, "/delete", body);
        if (response.status === 200) {
          this.search();
          this.showSuccess(response.data.message);
        } else {
          this.showError(response.data.message);
        }
      } catch (error) {
        console.error("Delete failed:", error);
      } finally {
        this.selectedReqsForBulkOps = []
      }
    },
    async restore(restoreType, selectedReqsForBulkOps) {
      const requestIds = this.reportTransactions.transactions
        .filter(txn => selectedReqsForBulkOps.includes(this.getUniqueIDValue(txn)))
        .map(txn => this.getUniqueIDValue(txn));
      if (requestIds.length === 0) return;

      const transaction = this.reportTransactions.transactions.find(txn => this.getUniqueIDValue(txn) === requestIds[0]);
      const fileName = transaction.fileName;

      let checkFileReqBody = {
        userId: this.userId,
        fileName: fileName
      };

      try {
        const response = await makeOpearationRequest(this.$acclConfigs, "/checkfile", checkFileReqBody);
        if (response.status === 200) {
          const availableFiles = restoreType == type.PROJECT ? [response.data] : response.data.availableFiles;
          const isDeleteFile = availableFiles[0].isDeleted;
          if (isDeleteFile === false) {
            let data = {
              userId: this.userId,
              action: action.REPLACE,
              type: restoreType,
              requestId: requestIds,
            };
            this.setConfirmModalValues(
              "Restore Confirmation",
              "The file already exists. Are you sure you want to restore ?",
              "Restore",
              "Cancel",
              data
            );
            this.openModal();
          } else if (isDeleteFile === true) {
            let data = {
              userId: this.userId,
              type: restoreType,
              requestId: requestIds,
            };
            this.restoreRecord(data);
          }
        }
      } catch (error) {
        if (error.status == 404) {
          let data = {
            userId: this.userId,
            type: restoreType,
            requestId: requestIds,
          };
          this.restoreRecord(data);
        } else {
          console.error('Error making api call', error);
        }
      }
    },
    async restoreRecord(data) {
      let body = {
        userId: data.userId,
        type: data.type,
        requestIds: data.requestId
      };
      try {
        const response = await makeOpearationRequest(this.$acclConfigs, "/restore", body);
        if (response.status === 200) {
          this.search();
          this.showSuccess(response.data.message);
        } else {
          this.showError(response.data.message);
        }
      } catch (error) {
        console.error("restore failed:", error);
      }
    },
    removeInvalidBEColumns(targetArray) {
      return targetArray.filter(
        (element) => !elementsToRemoveFromArray.includes(element)
      );
    },
    addUniqueElements(array, elements) {
      array.push(...elements);
      const uniqueElements = new Set(array);
      return Array.from(uniqueElements);
    },

    async searchWithQuery() {
      this.currentPage = 1;
      await this.search();
    },

    async search() {
      let searchValues = { queryValue: this.searchQuery.trim() };

      if (this.searchName != "") {
        searchValues = { ...searchValues, ...{ queryColumn: this.searchName } };
      }

      let fields = [...this.selectedColumns];
      const filters = this.initializeDefaultFilters();
      fields = this.addUniqueElements(
        fields,
        supportingColumns[this.tableProps.type]
      );
      let invalidColumns = invalidBEColumns[this.tableProps.type];
      fields = fields.filter((column) => !invalidColumns.includes(column));

      this.setFiltersFromRoute(filters);

      let payload = {
        userId: this.userId,
        type: this.tableProps.type,
        fields: fields,
        filters: filters,
        sort: {
          field: this.filterSortColumn,
          order: this.filterSortOrder,
        },
        pagination: {
          page: this.currentPage,
          pageSize: this.pageSize,
        },
      };

      if (searchValues != null) {
        payload = { ...payload, ...searchValues };
      }
      try {
        let response = {};
        if (api_mode == "actual") {
          response = await makeOpearationRequest(this.$acclConfigs, "/search", payload);
        } else {
          if (this.tableProps.type == type.SCHEMA) { response = mock_response.SCHMEA_SEARCH_API; }
          else if (this.tableProps.type == type.XSL) { response = mock_response.XSL_SEARCH_API; }
          else if (this.tableProps.type == type.XML) { response = mock_response.XML_SEARCH_API; }
          else if (this.tableProps.type == type.PROJECT) { response = mock_response.PROEJCT_SEARCH_API; }
          else if (this.tableProps.type == type.KAFKA) { response = mock_response.KAFKA_SEARCH_API; }
          else if (this.tableProps.type == type.USER_ROLES) { response = mock_response.USER_ROLES_SEARCH_API; }
          else if (this.tableProps.type == type.DOWNLOADS) { response = mock_response.DOWNLOADS_SEARCH_API; }
          else if (this.tableProps.type == type.MAPPER) { response = mock_response.USER_ROLES_SEARCH_API; }
          else if (this.tableProps.type == type.API) { response = mock_response.API_SEARCH_API; }
          else if (this.tableProps.type == type.ORCHESTRATION) { response = mock_response.ORCHESTRATION_SEARCH_API; }

        }
        if (response.status == 200 && !response.data.transactions.length) {
          this.noRecordFound = true;
        } else {
          this.noRecordFound = false;
        }
        if (
          response.status == 200 &&
          this.refreshReport.isAutoRefresh == false &&
          this.refreshReport.autoRefresh == true
        ) {
          this.refreshReport.isAutoRefresh = true;
          this.refreshReport.isAutoRefresh = setInterval(() => {
            this.search();
          }, this.refreshReport.interval);
        }
        this.reportTransactions = response.data;
        this.totalRecords = response.data.totalRecords;
        this.totalPages = Math.ceil(response.data.totalRecords / this.pageSize);

        // Reset the select all flag when new data is loaded
        this.isSelectAllUsed = false;
      } catch (error) {
        // Error handling - silenced for production
      } finally {
        this.loading = false;
      }
    },
    initializeDefaultFilters() {
      let filters = [];
      let isDeleteProps = false;
      if (Array.isArray(this.tableProps.filters)) {
        isDeleteProps = this.tableProps.filters.some(
          (filter) => filter.isDeleted === true
        );
      }
      if (this.tableProps.type === type.USER_ROLES) {
        filters = this.stateFilter.length >= this.states.length ? [] : this.removeInvalidBEColumns(this.stateFilter).map(item => ({ isDisabled: item }));
      } else if (this.tableProps.type === type.DOWNLOADS) {
        // For downloads, exclude isDeleted filter as Downloads table doesn't have this column
        filters = [
          { status: this.removeInvalidBEColumns(this.selectedFilter) },
        ]
      } else {
        filters = [
          { isDeleted: isDeleteProps },
          { status: this.removeInvalidBEColumns(this.selectedFilter) },
        ]
      }
      return filters;
    },
    refresh() {
      this.loading = false;
    },
    getUniqueIDValue(transaction) {
      const fileType = this.tableProps.type;
      return transaction[GRID_ACTION_DATA_ELEMENTS[fileType].requestIdKey];
    },
    getUniqueIDKey() {
      const fileType = this.tableProps.type;
      return GRID_ACTION_DATA_ELEMENTS[fileType].requestIdKey;
    },
    setFiltersFromRoute(existingFilters) {
      const filterMapping = ROUTER_PARAMS_GRID_FILTER_MAP[this.tableProps.type];
      if (!filterMapping) {
        return existingFilters;
      }
      for (const [paramKey, filterKey] of Object.entries(filterMapping)) {
        const paramValue = this.routerParams[paramKey];
        if (paramValue) {
          const index = existingFilters.findIndex(item => filterKey in item);
          if (index !== -1) {
            // Update existing filter
            existingFilters.splice(index, 1, { [filterKey]: paramValue });
          } else {
            // Add new filter
            existingFilters.push({ [filterKey]: paramValue });
          }
        }
      }
      return existingFilters;
    },


    async bulkViewYAMLFile(requestIds) {
      const actions = this.tableProps.actions;
      const fileType = this.tableProps.type;
      const popupTitle = actions?.view?.popupTitle;
      const filteredFiles = this.reportTransactions.transactions
        .filter(file => requestIds.includes(file[GRID_ACTION_DATA_ELEMENTS[fileType].requestIdKey]));

      const { userId, projectId } = filteredFiles[0];

      this.popupFileData = {
        files: filteredFiles.map(file => ({
          requestId: file[GRID_ACTION_DATA_ELEMENTS[fileType].requestIdKey],
          fileName: file.fileName || file.xsdName
        })),
        userId,
        projectId,
        popupTitle,
        fileType
      };
      this.showPopup = true;
      const titleResponse = await getTitle(this.$acclConfigs, this.popupFileData.projectId, this.userId, 'project');
      this.projectName = titleResponse.data.title;
    },

    async viewYAMLFile(data, userId) {
      try {
        this.popupData = {};
        this.showPopup = true;
        this.popUpLoading = true;

        let payload = {
          userId: getCookie(user.id),
          type: this.tableProps.type,
          requestId: data.requestId
        };
        const response = await makeOpearationRequest(this.$acclConfigs, "/view", payload);
        if (response.status === 200) {
          this.popupData.viewContent = response.data.data.sort((a, b) => a.order - b.order); // Sort by order
          this.popupData.fileName = data.fileName;
          this.popUpLoading = false;
        }
      } catch (error) {
        console.error('Failed to fetch YAML:', error);
      }
    },
    async bulkDownload(reqIdArr) {
      let data = {
        userId: getCookie(user.id),
        fileType: this.tableProps.type,
        requestId: reqIdArr
      }
      if (this.tableProps.type === type.XSL) {
        if (reqIdArr.length === 1) {
          this.backupSelections = [...this.selectedReqsForBulkOps];
          this.showTransformationFactoryPopup = true;
          this.pendingDownloadRequests = reqIdArr;
          return;
        } else {
          data.tfRequired = "no";
        }
      }
      this.download(data, true);
      this.selectedReqsForBulkOps = [];
      this.allSelectedReqs.clear();
    },
    handleTransformationFactoryChoice(choice) {
      this.showTransformationFactoryPopup = false;
      const { type } = this.tableProps;
      const data = {
        userId: getCookie(user.id),
        fileType: type,
        requestId: this.pendingDownloadRequests,
        tfRequired: choice
      };
      this.download(data, true);
      this.pendingDownloadRequests = [];
      this.backupSelections = [];
      this.selectedReqsForBulkOps = [];
      this.allSelectedReqs.clear();
    },
    async download(data, isBulk) {
      window.dispatchEvent(new Event('hide-tooltips'));
      let toastId = null;
      let payload;
      let endpoint;

      // Set default endpoint for all tables
      endpoint = "/download";

      // Handle Downloads table with different payload format and endpoint
      if (data.fileType === type.DOWNLOADS) {
        // For Downloads table: use download_url endpoint with binary_name payload
        const requestId = isBulk ? data.requestId[0] : data.requestId;
        const transaction = this.reportTransactions.transactions.find(txn =>
          this.getUniqueIDValue(txn) === requestId
        );

        payload = {
          userId: data.userId,
          type: "download_url",
          binary_name: transaction?.binaryName,
        };

        endpoint = "/download_url"; // Override endpoint specifically for Downloads
      } else {
        // For all other tables: use original format with default endpoint
        payload = {
          userId: data.userId,
          type: data.fileType,
          requestIds: isBulk ? data.requestId : [data.requestId],
        };

        // Add tfRequired parameter if it exists in the data
        if (data.tfRequired) {
          payload.tfRequired = data.tfRequired;
        }
      }

      // Change config to handle JSON response for async downloads
      let config = {
        responseType: "json", // Changed from "blob" to handle JSON response
      };

      try {
        toastId = this.hardShowLoading("Submitting download request...");
        const response = await makeOpearationRequest(this.$acclConfigs,
          endpoint, // Use dynamic endpoint (/download_url for Downloads, /download for others)
          payload,
          config
        );

        if (response.status === 202) {
          // Handle async download request accepted

          toast.update(toastId, {
            render: `${response.data.message || 'Download request accepted. Processing started.'}`,
            type: "info",
            isLoading: false,
            autoClose: 4000,
          });

          // Show additional success message
          this.showSuccess(
            `Request submitted successfully! ` +
            `Check the Downloads page to monitor progress and download when ready.`
          );

        } else if (response.status === 200) {
          // Handle immediate download (fallback for backward compatibility)

          // Check if response is a blob (direct download), URL string, or JSON (async)
          if (response.data instanceof Blob) {
            // Handle direct file download
            toast.update(toastId, {
              render: "File downloaded successfully.",
              type: "success",
              isLoading: false,
              autoClose: 2000,
            });

            const blob = new Blob([response.data], { type: response.data.type });
            // Retrieve the fileName
            let fileName = data.fileName;
            const contentDisposition = response.headers.get('content-disposition') || response.headers.get('Content-Disposition');
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
              if (fileNameMatch.length > 1) {
                fileName = fileNameMatch[1];
              }
            }
            fileName = fileName ?? "Migrated-Projects";
            // Create a link element and trigger the download
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = changeFileExtension(fileName, "zip");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          } else if (typeof response.data === 'string' && response.data.startsWith('http')) {
            // Handle pre-signed URL response - directly navigate to URL for download

            toast.update(toastId, {
              render: "File downloaded successfully.",
              type: "success",
              isLoading: false,
              autoClose: 2000,
            });

            // Create a temporary link element and trigger download from pre-signed URL
            const a = document.createElement("a");
            a.href = response.data;
            //a.target = "_blank"; // Open in new tab to ensure download
            a.download = ""; // Let browser determine filename from URL/headers
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } else {
            // Handle JSON response for immediate processing
            toast.update(toastId, {
              render: "Download request processed successfully.",
              type: "success",
              isLoading: false,
              autoClose: 3000,
            });

            this.showSuccess(
              `Download processed successfully! ` +
              `Check the Downloads page to access your file.`
            );
          }
        } else {
          console.error("Unexpected response status:", response.status);
          if (toastId != null) {
            toast.update(toastId, {
              render: "Download request failed",
              type: "error",
              autoClose: 3000,
              isLoading: false,
            });
          }
          this.showError("Download Failed");
        }
      } catch (error) {
        if (toastId != null) {
          toast.update(toastId, {
            render: "Download request failed",
            type: "error",
            autoClose: 3000,
            isLoading: false,
          });
        }
        this.showError("Download Failed");
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async xmlShowDiff(requestId) {
      const type = this.tableProps.type
      const requestIdsObj = this.reportTransactions.transactions
        .filter(file => requestId.includes(file.xmlId))
        .map(({ xmlId, xmlFileName }) => ({ xmlId, xmlFileName }));

      const data = {
        userId: this.userId,
        requestId: requestIdsObj,
        fileType: type,
      }
      this.setType(type);
      this.setValuesToSession(type, data.userId, data.requestId, "");
      this.$router.push({
        name: pageViews.XML_FILE_DIFFERENCE,

      });
    },


    async xslShowDiff(requestIds) {

      const type = this.tableProps.type
      const requestIdsObj = this.reportTransactions.transactions
        .filter(file => requestIds.includes(file.xslId))
        .map(({ xslId, xslFileName }) => ({ xslId, xslFileName }));

      const data = {
        userId: this.userId,
        requestIds: requestIdsObj,
        fileType: type,
        projectId: this.projectId,
      }
      this.setType(type);
      this.setValuesToSession(type, data.userId, data.requestIds, "");
      this.$router.push({
        name: pageViews.XSL_FILE_DIFF,

      });

      //type === type.XML ? this.redirectView(pageViews.XMLFILEDIFFERENCE, data) : this.redirectView(pageViews.FILEDIFFERENCE, data);
    },

    async xmlTransform(comptype, data) {
      this.setValuesToSession(comptype, data.userId, data.requestId, data.fileName);
      this.redirectView(pageViews.XMLTRANSFORM, data);
    },
    async trashView(type, userId) {
      this.setValuesToSession(type, userId);
      this.redirectView(pageViews.TRASHVIEW, {});
    },
    async redirectView(viewName, txnData) {
      let gridType = this.tableProps.type;
      redirect(this.tableProps.type, this.$router, this.routerParams, viewName, txnData)
    },
    addFile(event) {
      let droppedFiles = Array.from(event.dataTransfer.files);
      if (!droppedFiles) return;
      this.files = this.files.concat(droppedFiles);
    },
    removeFile(file) {
      this.files = this.files.filter((f) => f !== file);
    },

    formatSize(size) {
      return (size / 1024).toFixed(2);
    },
    onPageChange(page) {
      // Save current page's selection before changing page
      this.selectedReqsByPage[this.currentPage] = [...this.selectedReqsForBulkOps];

      this.selectAllCheckboxes = false;
      // Reset the select all flag when changing pages
      this.isSelectAllUsed = false;
      this.paginationStore.savePaginationState(this.$route.name, this.pageSize, page);
      this.currentPage = page;

      // Restore selection for the new page
      const pageKey = page;
      if (this.selectedReqsByPage[pageKey]) {
        this.selectedReqsForBulkOps = [...this.selectedReqsByPage[pageKey]];
      } else {
        this.selectedReqsForBulkOps = [];
      }
      // Set selectAllCheckboxes based on restored selection
      if (
        this.reportTransactions &&
        this.reportTransactions.transactions &&
        this.reportTransactions.transactions.length > 0 &&
        this.selectedReqsForBulkOps.length === this.reportTransactions.transactions.length
      ) {
        this.selectAllCheckboxes = true;
      } else {
        this.selectAllCheckboxes = false;
      }
      this.refresh();
      this.search();
    },
    onRecordChange(recordSize) {
      // Merge all previously selected records from all pages

      // Save current page's selection for persistence
      this.selectedReqsByPage[this.currentPage] = [...this.selectedReqsForBulkOps];

      // Only update pageSize, keep currentPage as is
      this.pageSize = recordSize;
      this.paginationStore.savePaginationState(this.$route.name, recordSize, this.currentPage);

      this.loading = false;
      this.search().then(() => {
        // After search, keep all previously selected records that are still visible
        const visibleIds = this.reportTransactions && this.reportTransactions.transactions
          ? this.reportTransactions.transactions.map(txn => this.getUniqueIDValue(txn))
          : [];
        // After search, update global selection with any visible selections
        this.selectedReqsForBulkOps.forEach(id => this.allSelectedReqs.add(id));
        // Now, show only those selected that are visible on this page
        this.selectedReqsForBulkOps = visibleIds.filter(id => this.allSelectedReqs.has(id));
        // Set selectAllCheckboxes if all visible records are selected
        if (
          visibleIds.length > 0 &&
          visibleIds.every(id => this.selectedReqsForBulkOps.includes(id))
        ) {
          this.selectAllCheckboxes = true;
        } else {
          this.selectAllCheckboxes = false;
        }
      });
    },
    handleClearSelection() {
      // Defensive: still keep this for the event, but main logic is above
      this.selectedReqsForBulkOps = [];
      this.selectAllCheckboxes = false;
      // Also clear for this page
      this.selectedReqsByPage[this.currentPage] = [];
      this.allSelectedReqs.clear();
    },
    startEditing(data, column) {
      const uniqueId = this.getUniqueIDValue(data);
      this.editingId = uniqueId + column.name;
      if (!(this.originalValues[uniqueId] && this.originalValues[uniqueId].hasOwnProperty(column.name))) {
        if (this.originalValues[uniqueId]) {
          this.originalValues[uniqueId][column.name] = data[column.name];
        } else {
          this.originalValues[uniqueId] = { [column.name]: data[column.name] };
        }
      }
    },
    isEditing(uniqueId, column) {
      return this.editingId === uniqueId + column.name;
    },
    trackChanges(data, column) {
      const uniqueId = this.getUniqueIDValue(data);
      const uniqueIdKey = this.getUniqueIDKey();
      const existingChange = this.changes.find(change => (change[uniqueIdKey] === data[uniqueIdKey]));
      const originalValue = this.originalValues[data[uniqueIdKey]] ? this.originalValues[data[uniqueIdKey]][column.name] : undefined;
      if (data[column.name].toString() !== originalValue.toString()) {
        if (existingChange) {
          if (!existingChange[`current_${column.name}`]) {
            existingChange[`current_${column.name}`] = originalValue.toString();
          }
          existingChange[column.name] = data[column.name];
        } else {
          this.changes.push({ ...data, [`current_${column.name}`]: originalValue.toString() });
        }
      } else {
        this.changes = this.changes
          .map(change => {
            if (change[uniqueIdKey] === data[uniqueIdKey].toString()) {
              const newChange = { ...change };
              Object.keys(change).forEach(key => {
                if (key.startsWith('current_') && key.slice(8) === column.name) {
                  delete newChange[key];
                }
                if (key === column.name) {
                  //delete newChange[key];
                  newChange[key] = data[key];
                }
              });
              return newChange;
            }
            return change;
          })
          .filter(change => {
            return Object.keys(change).some(key => key.startsWith('current_'));
          });
      }
      this.refinedEditableGridViewColumns = EDITABLE_GRID_CHANGES_COLUMNS[this.tableProps.type];
      //this.$emit('editableGridUpdated', this.changes);

      this.refinedEditableGridUpdatesToBeEmitted = {
        "originalChanges": this.changes,
        "refinedChanges": this.refinedChanges,
      }
      this.$emit('editableGridUpdated', this.refinedEditableGridUpdatesToBeEmitted);
    },
    discardEditableGridChanges() {
      this.resetEditableGrid();
      this.refresh();
      this.search();
    },
    resetEditableGrid() {
      this.changes = [];
      this.editingId = null;
      this.originalValues = {};
      this.refinedEditableGridViewColumns = [];
      this.refinedEditableGridUpdatesToBeEmitted = {};
    },
    async submitEditableGridChanges() {
      try {
        let payload = this.changes;
        if (EDITABLE_GRID_ACTIONS[this.tableProps.type].ingestionEndpoint === "/updateuser") {
          payload = {
            userId: this.userId,
            changes: this.changes
          };
        }
        const response = await makeOpearationRequest(this.$acclConfigs, EDITABLE_GRID_ACTIONS[this.tableProps.type].ingestionEndpoint, payload);
        if (response.status === 200) {
          this.resetEditableGrid();
          this.refresh();
          this.search();
          this.showSuccess(response.data.message);
        } else {
          this.showError(response.data.message);
        }
      } catch (error) {
        console.error("Update Failed:", error);
        throw error;
      }
    },
    getStatusColumns(record) {
      const statusColumns = [
        { icon: require('@/assets/icons/kafka-logo.png'), status: "jmsStatus", accuracy: "jmsAccuracy", routeTo: pageViews.KAFKACONFIGGENERATORVIEW, name: "Kafka" },
        { icon: require('@/assets/icons/Schema.png'), status: "schemaStatus", accuracy: "schemaAccuracy", routeTo: pageViews.SCHEMACONVERTERVIEW, name: "Schema" },
        { icon: require('@/assets/icons/xslticon.png'), status: "xslStatus", accuracy: "xslAccuracy", routeTo: pageViews.CONVERTERVIEW, name: "XSLT" },
        { icon: require('@/assets/icons/Connector.png'), status: "connectorStatus", accuracy: "connectorAccuracy", routeTo: pageViews.CONNECTOR_CONFIG_GENERATOR_VIEW, name: "Connector" },
        { icon: require('@/assets/icons/Mapper.png'), status: "mapperStatus", accuracy: "mapperAccuracy", routeTo: pageViews.MAPPERVIEW, name: "Mapping Docs" },
        { icon: require('@/assets/icons/Api.png'), status: "apiStatus", accuracy: "apiAccuracy", routeTo: pageViews.APIVIEW, name: "API" },
        // { icon: require('@/assets/icons/orchestration5.png'), status: "orchestrationStatus", accuracy: "orchestrationAccuracy", routeTo: pageViews.ORCHESTRATION_VIEW, name: "Orchestration" },
      ];
      return statusColumns.map(({ icon, status, accuracy, routeTo, name }) => {
        const statusValue = record[status] ? CONVERSION_STATUS.getByValue(record[status]).name : "-";
        const accuracyValue = record[accuracy] ? `${record[accuracy]}` : "0";
        let cssClass = "ok"; // Default green color for OK status
        let strokeDasharray = `${accuracyValue}, 100`; // Default stroke-dasharray for OK status

        if (statusValue === CONVERSION_STATUS.PROGRESS.name) {
          cssClass = CONVERSION_STATUS.PROGRESS.value; // Orange color for in progress
          strokeDasharray = "100, 100"; // Fully filled circle
        } else if (statusValue === CONVERSION_STATUS.NA.name) {
          cssClass = CONVERSION_STATUS.NA.value; // Black color for not applicable
          strokeDasharray = "100, 100"; // Fully filled circle
        } else if (statusValue === CONVERSION_STATUS.FAIL.name) {
          cssClass = CONVERSION_STATUS.FAIL.value; // Red color for failed
          strokeDasharray = "100, 100"; // Fully filled circle
        } else if (statusValue === CONVERSION_STATUS.NEW.name) {
          cssClass = CONVERSION_STATUS.NEW.value; // Blue color for new status
          strokeDasharray = "100, 100"; // Fully filled circle
        }

        return {
          icon,
          statusValue,
          accuracyValue,
          routeTo,
          cssClass,
          strokeDasharray,
          name,
          iconStyle: statusValue === CONVERSION_STATUS.NA.name ? { backgroundColor: '#ccc', cursor: 'not-allowed' } : {}
        };
      });
    },
    async calculateComplexity() {
      try {
        this.showCalcPopup = true;
        this.popupData.viewTitle = 'Complexity Calculation';
      } catch (error) {
        console.error('Failed to fetch YAML:', error);
      }
    },
    getTooltipText(action) {
      if (actionLabel.COMPARE.toLowerCase() == action.toLowerCase()) {
        SELECT_AT_LEAST_ONE_ITEM = "Select at least one item";
      }
      return this.selectedReqsForBulkOps.length === 0 ? `${SELECT_AT_LEAST_ONE_ITEM} to ${action}` : action;
    },
    handleRowClick(event, requestId, index) {
      // Prevent selection if user is highlighting text
      if (window.getSelection().toString()) {
        return;
      }

      if (event.shiftKey && this.lastSelectedIndex !== null) {
        // Get range for shift selection
        let min = Math.min(this.lastSelectedIndex, index);
        let max = Math.max(this.lastSelectedIndex, index);

        // Select all items in the range
        let newSelections = this.reportTransactions.transactions
          .slice(min, max + 1)
          .map(transaction => this.getUniqueIDValue(transaction));

        // Merge new selections while keeping unique values
        this.selectedReqsForBulkOps = [...new Set([...this.selectedReqsForBulkOps, ...newSelections])];
      } else if (event.ctrlKey || event.metaKey) {
        this.collateRequestIDs(requestId);
      } else {
        this.selectedReqsForBulkOps = [requestId];
      }
      this.lastSelectedIndex = index;
    },
    async connectorLibrary() {
      const payload = {
        userId: this.userId,
        type: "library"
      };

      let toastId = null; // For showing loading icon
      const config = { responseType: "blob" };

      try {
        toastId = this.hardShowLoading("Hang tight! Your download is on its way..");
        const response = await makeOpearationRequest(this.$acclConfigs, "/download", payload, config);

        if (response.status === 200) {
          toast.update(toastId, {
            render: "Connector Library downloaded successfully.",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });

          const blob = new Blob([response.data], { type: response.data.type });
          let fileName = "Connector_library.zip";
          const contentDisposition = response.headers.get('content-disposition') || response.headers.get('Content-Disposition');
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch.length > 1) {
              fileName = fileNameMatch[1];
            }
          }

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          console.error("Unexpected response status:", response.status);
          if (toastId != null) {
            toast.update(toastId, {
              render: "Download failed",
              type: "error",
              autoClose: 3000,
              isLoading: false,
            });
          }
          this.showError("Download Failed");
        }
      } catch (error) {
        console.error("Error during library download:", error);
        if (toastId != null) {
          toast.update(toastId, {
            render: "Download failed",
            type: "error",
            autoClose: 3000,
            isLoading: false,
          });
        }
        this.showError("An error occurred while downloading the library.");
      }
    },
    getStatusRouteUrl(transaction, status) {
      // Map status.routeTo to route name and params, You may need to adjust param keys for each accelerator type,Example assumes projectId is always the param
      if (!status.routeTo) return '#';
      try {
        return this.$router.resolve({
          name: status.routeTo,
          params: { projectParamId: transaction.projectId }
        }).href;
      } catch (e) {
        return '#';
      }
    },
    handleStatusIconClick(transaction, status) {
      // Only allow navigation if status is actionable (not Not Applicable)
      if (!['Not Applicable'].includes(status.statusValue) && status.routeTo) {
        this.$router.push({
          name: status.routeTo,
          params: { projectParamId: transaction.projectId }
        });
      }
    }
  }
}
</script>

<style scoped>
.custom-selected-row {
  background-color: #FFDEAD !important;
  --bs-table-bg: transparent !important;
}

.centered-dash {
  text-align: center !important;
}

.single-record-center {
  text-align: center !important;
}

.small-font {
  font-size: 0.7rem;
  margin-bottom: 0;
}

.back-button {
  margin-left: 15%;
  border-radius: 50% !important;
  background-color: rgba(255, 255, 255, 0.2);
  color: black;
  border: none !important;
  /* padding:  30px !important; */
  -webkit-transition: background-color 1s, color 1s, -webkit-transform 0.5s;
  transition: background-color 1s, transform 0.5s;
  box-shadow: 5px 0px 18px 0px rgba(105, 105, 105, 0.8);
}

.back-button:hover {
  -webkit-transform: translateX(-5px);
}

.fa-3x {
  font-size: 2.5rem;
}

.sortbtn:hover,
.sortbtn {
  background-color: white;
  border-color: white;
  /* border-radius: 6px; */
  height: 5vh;
  width: 8vw;
  color: #da6a26;
  text-align: center;
  font-weight: bolder;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 10px;
  /* margin-left: 1rem; */
  /* margin-right: 12rem; */
}

.sortlbl {
  text-align: center;
  padding-top: 12px;
  padding-right: 3px;
  padding-left: 2px;
  padding-bottom: 8px;
}

.sortbtn.show {
  background-color: white;
  color: #da6a26;
}

.subitbtn {
  background-color: #da6a26;
  color: white;
  border: none;
  border-radius: 7px;
  height: 6vh;
  width: 10vw;
  text-align: center;
  font-weight: bolder;
}

.sort .sortbtn {
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 10px;
  margin-left: 1rem;
}

.sort {
  width: 22% !important;
  margin-left: 0.8rem;
  background-color: #da6a26;
  color: white;
  border: none;
  align-content: space-evenly;
  border-radius: 7px;
  text-align: left;
  text-justify: left;
  font-weight: bolder;
  /* height: 3vh; */
  /* width: 11vw; */
  float: left;
  padding: 0px 32px 0px 12px !important;
  /* margin-left: -2.5rem; */
}

.label {
  display: none;
  margin-left: 10px;
}

.xml-tranform-sidebar-menu {
  top: 35%;
}

.submitbtn {
  align-content: center;
}

.loading-gif {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 130px;
  width: 130px;
}

.loading-gif img {
  max-width: 100%;
  /* Ensure the image scales properly */
  max-height: 100%;
  /* Ensure the image scales properly */
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}

/* loading icon end */

.filterButton {
  text-align: center;
  height: 35px;
  background-color: #1D2856 !important;
  /* color: white !important;
  border: none;
  border-radius: 7px;
  text-align: center;
  font-weight: bolder;
  align-items: center;
  justify-content: center; */
}

/* .btn-small {
  --bs-btn-padding-y: 0.55rem;
    --bs-btn-padding-x: 0.5rem;
    --bs-btn-font-size: 0.850rem;
    --bs-btn-border-radius: var(--bs-border-radius-sm);
} */

.search-form {
  display: flex;
  align-items: center;
}

.col-sel-btn {
  margin-left: 0.2rem;
}

.constabtn {
  margin-left: 1%;
}

.empty {
  margin-right: -11rem;
}

.srch {
  /* margin-left: 5rem;
  margin-right: 6rem; */
}

.clrbtn {
  margin-left: 7rem;
  width: 7vw;
}


.cus-table-header-sticky {
  position: sticky;
  top: 0;
  right: 0;
  z-index: 1;
  width: 50px !important;
}

.table-header-sticky {
  height: 0%;
  top: 0;
  z-index: 1;

}

/* diff container design start */

.diff-container {
  white-space: normal;
  margin-top: 20px;
}

/* Custom styles to decrease line spacing */
.diff-container .d2h-wrapper .d2h-side-by-side .d2h-code-side-line {
  padding: 2px 10px;
  /* Adjust the padding to reduce space */
}

.diff-container .d2h-wrapper .d2h-side-by-side .d2h-code-line {
  margin: 0;
  /* Remove the default margin */
}

.diff-container .d2h-wrapper .d2h-side-by-side td.d2h-code-side-linenumber {
  padding: 2px 5px;
  /* Adjust the padding of line numbers */
}

/* diff container design end */
.fileName-align {
  text-align: left;
}

.table-group-divider span {
  font-size: 10px;
}

/* table design start */

.custom-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border: 3px solid #ddd;
  border-radius: 8px;
  table-layout: auto;

  text-align: center;
  position: relative;
  white-space: nowrap;
  overflow-y: auto;

  /*TODO remove flex*/
  flex: 1;
  /* Take remaining space in the outer div */
  box-sizing: border-box;
  /* Include padding and border in width/height */
}

.track-changes-table th {
  background-color: lightgrey;
  color: #000;
}

.custom-table th,
.custom-table td {
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
}

.nowrap {
  flex-wrap: nowrap;
  display: inline-flex;
}

.custom-table th {
  background-color: #da6a26;
  color: whitesmoke;
}

.table-responsive {
  display: flex;
  /* Optional: Flex for layout purposes */
  flex-direction: column;
  /* Stack content vertically */
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  max-height: calc(100vh - 200px);
}

table,
td {
  border: 1px;
}

th {
  border: 1px;
  cursor: pointer;
  position: relative;
}

.xml-tranfomer-dropdown-upload-icon {
  margin-left: 0px;
}

.xml-tranfomer-dropdown-para {
  margin-left: 10px;
}

.btn-view {
  background: url("@/assets/icons/view.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  height: 23px;
  width: 26px;
  border: none;
}

.btn-download {
  background: url("../../assets/icons/convert2.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  height: 23px;
  width: 26px;
  border: none;
}

.btn-show-difference {
  background: url("../../assets/icons/compare.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  height: 23px;
  width: 26px;
  widows: 30px;
  border: none;
  object-fit: cover;
}

.btn-delete {
  background: url("../../assets/icons/delete-red2.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  height: 20px;
  width: 26px;
  border: none;
}

.cloud-download {
  font-size: 30px;
  height: 36px;
  margin-top: -10px;
  border: none;
  background-color: white;
  color: #1D2856 !important;
}

.btn-view:disabled,
.cloud-download:disabled,
.btn-show-difference:disabled,
.btn-delete:disabled,
.btn-restore:disabled,
.btn-generate:disabled,
.btn-transform:disabled,
.btn-calculate:disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.btn-restore {
  background: url("../../assets/icons/restorebtn1.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  height: 23px;
  width: 26px;
  border: none;
}

.btn-generate {
  background: url("../../assets/icons/icons8-ai.svg");
  background-repeat: no-repeat;
  background-size: contain;
  font-size: 12px;
  margin-left: 5px;
  height: 26px;
  width: 26px;
  border: none;
  /* margin-top: -1px; */
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.btn-trash {
  background: url("../../assets/icons/recycle-icon.svg");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: center;

  font-size: 10px;
  margin-left: 5px;
  height: 20px;
  width: 20px;
  border: none;
}

.btn-transform {
  background: url("../../assets/icons/transform.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  /* Space between icon and text */
  height: 23px;
  width: 26px;
  widows: 30px;
  border: none;
}

.btn-calculate {
  background: url("../../assets/icons/calculator-blue.svg");
  background-repeat: no-repeat;
  font-size: 12px;
  height: 26px;
  width: 26px;
  border: none;
}


.btn-download:disabled,
.btn-show-difference:disabled,
.btn-delete:disabled,
.btn-restore:disabled,
.btn-generate:disabled,
.btn-trash:disabled,
.btn-transform:disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.t .button-group {
  height: 35px;
  float: left;
  margin: 10px;
}

.xml-tranfomer-dropdown {
  background: #666;
  height: 100px;
  width: 300px;
  border: #ccc;
}

.xml-tranfomer-dropdown img {
  height: 30%;
  width: 40%;
}

.container {
  max-width: 95%;
  margin-top: 100px;
}

.file-upload {
  width: 20%;
  height: 58vh;
  border: 2px dashed #333;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  float: left;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 8vw;
}

.mapper-view .report {
  width: 80%;
  height: 20vh;
  float: left;
}


.report-sub {
  margin-top: 5rem;
  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);
  height: 10vh;
  width: 90%;
  border: 2px dashed #333;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  margin-left: 5%;
}

.table-custom tbody tr:nth-of-type(odd) {
  background-color: #f2f2f2;
}

.table-custom tbody tr:nth-of-type(even) {
  background-color: #d9d9d9;
}

h1 {
  font-size: 3em;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 0.5em;
  margin-top: 1vh;
}

h4 {
  font-size: 1.2em;
  font-weight: normal;
  color: #666;
  text-align: center;
  margin-bottom: 1em;
}

.file-upload-sub {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 8vw;
}

.file-upload:hover {
  border-color: #da6a26;
}

.file-upload input[type="file"] {
  display: none;
}

.file-upload button {
  filter: drop-shadow(0 15px 25px rgba(222, 98, 7, 0.15));
  display: inline-block;
  border: none;
  background: #da6a26;
  color: white;
  padding: 15px 40px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 50px;
  text-decoration: none;
  transition: background-color 0.3s ease;
  justify-content: center;
}

.file-upload button:disabled {
  background-color: #ccc;
  /* Change this to your preferred disabled color */
  cursor: not-allowed;
}

.file-upload button:hover {
  background-color: #333;
}

.file-upload ul {
  list-style-type: none;
  padding: 0;
  width: 100%;
}

.file-upload li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 10px;
  margin: 5px 0;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.file-upload li:hover {
  background-color: #f1f1f1;
}

.file-upload li button[title="Remove"] {
  background-color: #da6a26;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.file-upload li button[title="Remove"]:hover {
  background-color: #da6a26;
}

.file-upload p {
  color: #030a07;
  font-weight: bold;
  margin-top: 10px;
  text-align: center;
}

nav {
  background-color: #cd7838;
  padding: 1em;
}

ul {
  list-style-type: none;
  padding: 0;
  overflow-y: scroll;
  max-height: 20rem;
}

li {
  /* display: inline; */
  /* margin-right: 1em; */
  margin-top: 1vh;
}

a {
  /* color: white; */
  text-decoration: none;
}

.sticky {
  position: sticky;
  right: 0;
  z-index: 0;
  width: 12%;
  box-shadow: 15px 0 15px -15px #da6a26, -9px 0 8px 0px #a9a9a9;
}

.scroll-class {
  /* height: min-content;
  overflow: scroll; */
  max-height: 150px;
  /* Set your desired max-height */
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 0;
  margin: 10px 0;
  list-style-type: none;
}

.scroll-class li {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  border-bottom: 1px solid #eee;
}

.srchip {
  width: 22rem;
  margin-right: 0.5rem;
}

.divalignleft {
  margin-left: -7rem;
}

.clrdiv {
  margin-left: -0.5rem;
}

.svg-button {
  /* margin-top: -1.5rem !important; */
  float: right;
  align-items: center;
  border: none;
  background-color: #da6a26;
  cursor: pointer;
  color: white;
}

.sort-buttons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  display: flex;
  gap: 0.5em;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.clear-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 1.2em;
  color: #aaa;
  user-select: none;
}

.clear-button:hover {
  color: #000;
}

.grayed-out {
  color: gray;
  opacity: 0.6;
}

.filter-icon-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.clear-filter-icon {
  margin-left: 10px;
  margin-right: 10px;
  border: none;
  background: unset;
  transform: translateX(-20px);
}

.clear-filter-icon:hover .filter-icon {
  filter: brightness(1.5);
  transform: scale(1.2);
  filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.5));
}

/**Styles for actionable and non actionable columns */
.text-success {
  transition: font-size 0.3s ease;
}

.text-danger {
  transition: font-size 0.3s ease;
}

.text-new-status {
  color: #1d2856;
  transition: font-size 0.3s ease;
}

.text-in-progress {
  color: #cd7838;
  transition: font-size 0.3s ease;
}

.text-not-applicable {
  color: #2b3b78;
  transition: font-size 0.3s ease;
}

.actionable:hover {
  font-size: 1.1em;
  text-decoration: underline;
  cursor: pointer;
}

.usecase-link {
  color: #0066cc;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.usecase-link:hover {
  color: #0056b3;
  text-decoration: underline;
  font-size: 1.05em;
}

.dropdown-item {
  line-height: 1.4;
}

.getOverrideCssClass {
  text-align: left;
}

.actions-dropdown-toggle {
  background: url("../../assets/icons/menu.svg") no-repeat center center;
  background-size: contain;
  cursor: pointer;
  outline: none;
  transition: background-image 0.3s ease;
  height: 26px;
  width: 26px;
  border: none;
}

.actions-dropdown-toggle.show {
  background-image: url("../../assets/icons/menu_open.svg");
  transform: rotate(90deg);
}

.icon-row {
  display: flex;
  justify-content: space-around;
  padding: 10px;
}

/* Icon style */
.icon {
  width: 24px;
  height: 24px;
}

.gloss-view-content {
  text-align: center;
  display: grid;
}




.toolbar {
  display: flex;
  justify-content: flex-start;
  margin-top: 16px;
}

.pointer {
  cursor: pointer;
}

select {
  border: 1px solid #ccc;
  /* Border color */
  border-radius: 9px;
  /* Rounded corners */
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.3s;
}

select:focus {
  outline: none;
  /* Remove outline */
  box-shadow: 0 0 5px rgba(255, 179, 0, 0.676);
  /* Box shadow on focus */
}

/**In-progress status to blink 
.blink {
  display: inline-block;
  animation: blink 1.5s infinite; 
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}*/
</style>
<style>
.custom-tooltip .tooltip-inner {
  background-color: lightgray;
  color: black;
}

.custom-ellipsed-text-tooltip {
  position: absolute;
  background-color: lightgray;
  color: rgba(0, 0, 0, 0.723);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 1000;
  pointer-events: none;
  white-space: pre-wrap;
}


.status-container {
  position: relative;
  display: inline-block;
  margin-right: 10px;
  /* Add space between icons */
  vertical-align: middle;
  /* Align icons vertically in the middle */
  z-index: 0;
  /* Ensure icons stay behind the column headers */
}

.status-text {
  visibility: hidden;
  width: auto;
  background-color: lightgray;
  color: black;
  text-align: left;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 20%;
  left: -100%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.status-container:hover .status-text {
  visibility: visible;
}

.menu-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.btn-item {
  background-color: #da6a26;
  color: white;
  width: 150px;
  height: 40px;
  border: none;
  border-radius: 4px;
  margin: 1px;
  cursor: pointer;
}

.progress-circle {
  position: relative;
  width: 45px;
  height: 45px;
}

.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}

.circle {
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
  transition: stroke-dasharray 0.3s ease;
}

.circle.ok {
  stroke: #4caf50;
  /* Green for success */
}

.circle.in-prog {
  stroke: #FFA500;
  /* Orange for in progress */
}

.circle.NA {
  stroke: #000000;
  /* Black for not applicable */
}

.circle.fail {
  stroke: #FF0000;
  /* Red for failed */
}

.circle.new {
  stroke: #1E90FF;
  /* Blue for new */
}

.status-icon {
  transition: transform 0.3s ease;
  margin-right: 15px;
  transform-origin: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.status-icon:hover {
  transform: scale(1.8) translateX(-8.0px) translateY(-8.0px);
  cursor: pointer;
  z-index: 1;
  /* Ensure the icon stays above the context menu */
}

.custom-row {
  --bs-gutter-x: 1.0rem;
}

/* Custom scrollbar styles */
.table-responsive::-webkit-scrollbar {
  height: 8px;
  /* Adjust scrollbar width */
  width: 8px;
  /* Adjust scrollbar width */
}

/* Track (background of the scrollbar) */
.table-responsive::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  /* Light transparent background */
  border-radius: 10px;
}

/* Handle (scrollbar thumb) */
.table-responsive::-webkit-scrollbar-thumb {
  background: linear-gradient(45deg, #ff6b6b, #556270);
  /* Gradient effect */
  border-radius: 10px;
  transition: all 0.3s ease;
}

/* Handle on hover */
.table-responsive::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(45deg, #ff4e50, #fc913a);
  box-shadow: 0px 0px 10px rgba(255, 78, 80, 0.8);
}
</style>
